import { useLocation, useOutletContext } from "react-router-dom";
import PageTitle from "@/components/PageTitle";
import { JobsOutletContext } from "@/pages/_layouts/jobs/JobPostIndexLayout";
import ViewJobInteractions from "@/pages/_layouts/jobs/_components/ViewJobInteractions";

export default function JobPostInteractions() {
  const location = useLocation();
  const { data, title } = useOutletContext<JobsOutletContext>();

  if (!data?.jobPost) return null;

  return (
    <>
      <PageTitle pattern={location.pathname} title={`${title} | Jobs | Job Post Interactions`} />
      <ViewJobInteractions jobPost={data.jobPost} />
    </>
  );
}
